import React from "react";
import { count } from "../../../core/data/auditsPage";
import { INDUSTRY } from "../../../core/theme/auditsTheme";
import AdaAvatar from "../../../core/layout/AdaAvatar";
import wordmark from "../../../assets/brand/ada-wordmark.svg";

// Bottom left: AdA on the selected industry. For now one real line of what
// has been gathered; her observed facts and suggested searches come in B2
// stage 4.
export default function AdaPanel({ industry, niche }) {
  const parts = [count(industry.snapshots, "Snapshot", "Snapshots")];
  if (niche) parts.push(count(niche.locations, "location", "locations"), count(niche.keywords, "keyword", "keywords"));

  return (
    <section aria-label="AdA" className={`${INDUSTRY.panel} ${INDUSTRY.ada}`}>
      <div className={INDUSTRY.adaHead}>
        <AdaAvatar size={1.875} title="" />
        <img src={wordmark} alt="AdA." className={INDUSTRY.adaWordmark} />
        <span className={INDUSTRY.adaOn}>on {industry.name}</span>
      </div>
      <p className={INDUSTRY.adaLine}>{parts.join(" · ")} gathered so far.</p>
    </section>
  );
}
